__turbopack_context__.v({
  "card": "Bu-zkq_card",
  "confirmIcon": "Bu-zkq_confirmIcon",
  "confirmList": "Bu-zkq_confirmList",
  "confirmation": "Bu-zkq_confirmation",
  "error": "Bu-zkq_error",
  "footer": "Bu-zkq_footer",
  "footerNote": "Bu-zkq_footerNote",
  "form": "Bu-zkq_form",
  "header": "Bu-zkq_header",
  "hint": "Bu-zkq_hint",
  "homeLink": "Bu-zkq_homeLink",
  "input": "Bu-zkq_input",
  "inputGroup": "Bu-zkq_inputGroup",
  "label": "Bu-zkq_label",
  "logoLink": "Bu-zkq_logoLink",
  "main": "Bu-zkq_main",
  "page": "Bu-zkq_page",
  "row": "Bu-zkq_row",
  "spin": "Bu-zkq_spin",
  "spinner": "Bu-zkq_spinner",
  "stepLabel": "Bu-zkq_stepLabel",
  "submitButton": "Bu-zkq_submitButton",
  "subtitle": "Bu-zkq_subtitle",
  "textarea": "Bu-zkq_textarea",
  "title": "Bu-zkq_title",
});
